import globalIP from '@/GlobelIP';
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import {
  Breadcrumb,
  Button,
  ButtonToolbar,
  Checkbox,
  Col,
  Divider,
  FlexboxGrid,
  IconButton,
  Loader,
  Message,
  Modal,
  Panel,
  Stack,
  toaster
} from 'rsuite';
import JSZip from 'jszip';
import NavD from './NavD';
import { useInView } from 'react-intersection-observer';
import ugr from '@/UGRoute';
import SortUpIcon from '@rsuite/icons/SortUp';
import Resizer from 'react-image-file-resizer';
import ProductCard from '@/components/ProductSearchPage/ProductCard';
import ImageEditModal from './ImageEditModal';
import useUser from '../../../components/UseUser';
import { Dropdown } from 'antd';
import { EyeFilled } from '@ant-design/icons';
interface PaginationData {
  page: number;
  pageSize: number;
  pageCount: number;
  total: number;
}
interface MetaData {
  pagination: PaginationData;
}

const ProductImage = ({ activeKey, handleNavSelect, label }) => {
  const { user } = useUser();
  const [selectedItems, setSelectedItems] = useState([]);

  const [data123, setData123] = useState([]);
  const [meta123, setMeta123] = useState<MetaData>();
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(0);
  const [stopInfininitescrol, setStopInfininitescrol] = useState(true);
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [downloadAllImg, setDownloadAllImg] = useState(false);

  useEffect(() => {
    if (selectedItems.length == 0 || selectedItems.length < data123.length) {
      setIsAllSelected(false);
    } else {
      setIsAllSelected(true);
    }
  }, [selectedItems.length]);

  const handleOpenBulkEdit = () => {
    if (selectedItems.length == 0) {
      toaster.push(
        <Message showIcon type="error">
          Select atleast 1 Product to continue.
        </Message>,
        { placement: 'topEnd' }
      );
      return;
    }
    setEditOpen(true);
  };


  useEffect(() => {
    fetchDatas();
  }, []);

  const fetchDatas = async () => {
    try {
      const response = await fetch(`${globalIP}/api/company-details?populate=*`);
      const json = await response.json();
      setDownloadAllImg(json.data[0].attributes.DownloadAllImage ?? false);
    } catch (err) {
      console.error("Error:", err);
    }
  };
  const handleCheckAll = checked => {
    setSelectedItems(checked ? data123.map(item => item.id) : []);

    setIsAllSelected(checked);
  };
  const handleCheckboxChange = (value, checked) => {
    if (checked) {
      setSelectedItems(prevSelectedItems => [...prevSelectedItems, value]);
    } else {
      setSelectedItems(prevSelectedItems => prevSelectedItems.filter(item => item !== value));
    }
  };
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth' // Optional - adds smooth scroll animation
    });
  };
  const { ref, inView } = useInView({
    rootMargin: `0px 0px ${700}px 0px`
  });

  useEffect(() => {
    if (inView && limit && stopInfininitescrol) {
      setCurrentPage(prev => prev + 1);
    }
  }, [inView]);
  useEffect(() => {
    fetchData();
  }, []);
  const fetchData = async () => {
    if (isLoading) {
      return;
    }
    setIsLoading(true);
    let showpFilter = `&filters[Authorized][$eq]=Authorised`;
    const response = await fetch(
      `${globalIP}/api/products?populate=*&sort[0]=id:desc&pagination[page]=${currentPage}${showpFilter}`
    );
    const json = await response.json();
    setLimit(json.data.length);

    if (currentPage === 1) {
      setData123(json.data);
    } else {
      setData123(prevData => [...prevData, ...json.data]);
    }
    setMeta123(json.meta);
    setIsLoading(false);
  };
  const [page, setPage] = React.useState(1);
  useEffect(() => {
    fetchData();
  }, [currentPage]);
  const deletePrevImg = async fileId => {
    try {
      const response = await fetch(`${globalIP}/api/upload/files/${fileId}`, {
        method: 'DELETE'
      });

      if (!response.ok) {
        throw new Error('Failed to delete the file');
      }
      // alert('File deleted successfully');
    } catch (error) {
      console.error('Error deleting file');
    }
  };
  const [alldata123, setAllData123] = useState([]);
  const fetchAllData = async () => {
    const productResponse = await fetch(`${globalIP}/api/products?populate=*&pagination[page]=1`);
    const productData = await productResponse.json();
    const allData = [];

    for (let page = 1; page <= productData.meta.pagination.pageCount; page++) {
      const pageResponse = await fetch(
        `${globalIP}/api/products?populate=*&pagination[page]=${page}`
      );
      const pageJson = await pageResponse.json();
      allData.push(...pageJson.data);
    }
    setAllData123(allData);
  };
  useEffect(() => {
    fetchAllData();
  }, []);
  const [downloadingImages, setDownloadingImages] = useState(false);
  const downloadImages = async () => {
    setDownloadingImages(true);
    const zip = new JSZip();
    let allData =
      selectedItems.length > 0
        ? alldata123.filter(item => selectedItems.includes(item.id))
        : alldata123;

    const urls = allData
      .filter(
        item =>
          item?.attributes?.CoverImage != null &&
          item?.attributes?.CoverImage?.data?.attributes.url != undefined
      )
      .map((item, index) => ({
        url: `${globalIP + item?.attributes?.CoverImage?.data?.attributes.url}`,
        name: `${item?.attributes?.ProductId}`,
        index
      }));


    // Create promises for image downloading
    const downloadPromises = urls.map(async ({ url, name, index }) => {
      try {
        const response = await fetch(url);
        const blob = await response.blob();

        // Add the image blob to the zip
        zip.file(`${name}.jpg`, blob);
      } catch (err) {
        console.error(`Download failed for ${name} at index ${index + 1}:`, err);
      }
    });

    // Wait for all image downloads to complete
    await Promise.all(downloadPromises);

    // Generate the ZIP file and trigger the download
    zip
      .generateAsync({ type: 'blob' })
      .then(function (content) {
        // Create a download link for the ZIP file
        const link = document.createElement('a');
        link.href = URL.createObjectURL(content);
        link.download = 'images.zip'; // Name of the zip file
        link.click();
        setDownloadingImages(false);
      })
      .catch(err => {
        console.error('Error generating ZIP file:', err);
        setDownloadingImages(false);
      });
  };

  const [changingImages, setChangingImages] = useState(false);

  //**fetch products for image updating to load whole data at once */
  const fetchAllProducts = async () => {
    try {
      const allProducts = [];
      let page = 1;
      const pageSize = 1000000000;
      let totalFetched = 0;

      while (true) {
        const res = await fetch(`${globalIP}/api/products?pagination[page]=${page}&pagination[pageSize]=${pageSize}`);
        const data = await res.json();
        allProducts.push(...data.data);

        totalFetched += data.data.length;
        if (totalFetched >= data.meta.pagination.total) break;

        page++;
      }

      return allProducts;
    } catch (error) {
      console.error("Error fetching all products:", error);
      return [];
    }
  };

  const updateCoverImages = async () => {
    const allProducts = await fetchAllProducts()
    try {
      // Step 1: Open a file dialog to select the image folder
      const input = document.createElement('input');
      input.type = 'file';
      input.accept = '.jpg,.jpeg,.png'; // Allow .jpg, .jpeg, and .png files
      input.multiple = true;
      input.addEventListener('change', async event => {
        setChangingImages(true);
        const files = Array.from(event.target.files); // List of files in the folder
        // Extract image file names
        const imageNames = files.map(file => file.name);

        // Step 2: Fetch products from the API

        // Step 3: Loop through products and match with image names
        for (const product of allProducts) {
          const productId = product.attributes.ProductId;

          // Match images with ProductId
          const matchingImage = imageNames.find(name => {
            const nameWithoutExtension = name.toLowerCase().replace(/\.[^/.]+$/, '');
            return nameWithoutExtension?.toLowerCase()?.trim() === productId?.toLowerCase()?.trim();
          });

          if (matchingImage) {
            const matchedFile = files.find(file => file.name === matchingImage);

            // Skip invalid files here, as we already validated at the beginning
            if (!['image/jpeg', 'image/jpg', 'image/png'].includes(matchedFile.type)) {
              toaster.push(
                <Message showIcon type="error">
                  File named "{matchedFile.name}" is not a valid JPG/PNG file.
                </Message>,
                { placement: 'topCenter' }
              );

              continue; // Skip invalid file
            }

            if (product?.attributes?.CoverImage?.data?.id) {
              await deletePrevImg(product.attributes.CoverImage.data.id);
            }

            // // Step 4: Convert file to a Blob
            // const fileBlob = await fileToBlob(matchedFile);

            // // Step 5: Resize the Blob using the resizeFile function
            // const resizedBase64 = await resizeFile(fileBlob);

            // // Step 6: Convert the Base64 string to Blob using base64ToBlob function
            // const resizedBlob = base64ToBlob(resizedBase64, 'image/jpeg');

            const fileBlob = matchedFile;
            // Step 7: Create FormData and append the resized Blob
            const formData = new FormData();
            formData.append('files.CoverImage', fileBlob, matchedFile.name); // Append resized Blob with original file name

            // Include existing product data in the request payload
            const updatedData = {
              ...product.attributes // Add previous product attributes
            };
            delete updatedData.CoverImage; // Avoid overwriting CoverImage with null
            formData.append('data', JSON.stringify(updatedData));

            // Step 8: Update product CoverImage via Strapi API
            const updateUrl = `${globalIP}/api/products/${product.id}`;
            await fetch(updateUrl, {
              method: 'PUT',
              body: formData
            });

          }
        }
        setChangingImages(false);

        // Show confirmation dialog and reload the page if user presses "OK"
        const userConfirmed = window.confirm(
          'CoverImage update process completed! Do you want to reload the page?'
        );
        if (userConfirmed) {
          window.location.reload(); // Reload the page
        }
      });

      input.click(); // Trigger the file dialog
    } catch (error) {
      console.error('Error updating CoverImage:', error);
      alert('An error occurred while updating images.');
      setChangingImages(false);
    }
  };

  // Helper function to convert a file to Blob
  const fileToBlob = file => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        // Create a Blob from the ArrayBuffer result
        const blob = new Blob([reader.result], { type: file.type });
        resolve(blob);
      };
      reader.onerror = reject;
      reader.readAsArrayBuffer(file); // Read file as ArrayBuffer
    });
  };

  // Helper function to resize the image file (Blob)
  const resizeFile = blobfile =>
    new Promise(resolve => {
      Resizer.imageFileResizer(
        blobfile,
        1500,
        1500,
        'JPEG',
        90,
        0,
        uri => {
          resolve(uri); // Resolving with the resized Base64 string
        },
        'base64', // Return as base64
        900,
        900
      );
    });

  // Helper function to convert Base64 to Blob
  function base64ToBlob(base64, mimeType) {
    // Decode the base64 string into a byte array
    const byteCharacters = atob(base64.split(',')[1]);

    // Create a byte array of the same length as the decoded data
    const byteArrays = [];

    // Convert each character to its byte value
    for (let offset = 0; offset < byteCharacters.length; offset++) {
      byteArrays.push(byteCharacters.charCodeAt(offset));
    }

    // Create a Blob object using the byte arrays and the MIME type
    const byteArray = new Uint8Array(byteArrays);
    return new Blob([byteArray], { type: mimeType });
  }


  const [editOpen, setEditOpen] = useState(false);
  const items = [
    { key: "content1", label: "All Products" },
    { key: "content2", label: label[0]?.attributes?.Collection },
    { key: "content3", label: "Image Edit" },
    { key: "content4", label: "Variant Products" },
    { key: "content5", label: "Space Visualization" },
  ];
  return (
    <>
      <div
        style={{
          justifyContent: 'space-between',
          width: '-webkit-fill-available',
          position: 'fixed',
          height: '138px',
          background: '#fff',
          zIndex: 1
        }}
      >
        <Stack className="table-toolbar product-head" justifyContent="space-between">
          <Stack direction="column" alignItems="flex-start">
            <Stack direction="column" alignItems="flex-start" className="product-det">
              <Stack direction="row" alignItems="flex-start" spacing={157}>
                {/* <NavD activeKey={activeKey} handleNavSelect={handleNavSelect} label={label} /> */}
              </Stack>
              <Breadcrumb>
                <Breadcrumb.Item>
                  <Link to={`/${ugr}/dashboard`}>Home</Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item
                  active={activeKey === 'content1'}
                  onClick={() => handleNavSelect('content1')}
                >
                  Product
                </Breadcrumb.Item>
                <Breadcrumb.Item
                  active={activeKey === 'content3'}
                  onClick={() => handleNavSelect('content3')}
                >
                  Image Edit
                </Breadcrumb.Item>
              </Breadcrumb>
            </Stack>
          </Stack>
          <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
            <div>
              <b>Products: {data123.length + '/' + meta123?.pagination?.total}</b>
            </div>
            <Dropdown
              menu={{
                items,
                onClick: ({ key }) => handleNavSelect(key),
              }}
              trigger={["click"]}
            >
              <Button>
                View <EyeFilled />
              </Button>
            </Dropdown>
            <ButtonToolbar>
              <div
                style={{
                  // scale:"0.9",
                  paddingInline: '10px',
                  border: '1px solid gray',
                  borderRadius: '7px',
                  display: 'inline-flex',
                  width: '208px',
                  justifyContent: ' space-between',
                  alignItems: 'center',
                  paddingBlock: '0px',
                  marginBlock: '0px'
                }}
              >
                <Checkbox
                  checked={isAllSelected}
                  onChange={(_, checked) => handleCheckAll(checked)}
                  indeterminate={selectedItems.length > 0 && !isAllSelected}
                >
                  <p
                    style={{
                      textDecoration: 'none',
                      color: 'black !important'
                    }}
                  >
                    Select All
                  </p>
                </Checkbox>
                <Button
                  appearance="primary"
                  color="cyan"
                  size="sm"
                  onClick={handleOpenBulkEdit}
                  style={{ height: '25px', paddingBlock: '0px', marginBlock: '0px' }}
                >
                  Bulk Edit
                </Button>
              </div>
              {/* {(user.PRDpicdwnld === true || user.Category === 'Admin') && (
              <>
                {alldata123.length > 0 && (
                  <Button
                    onClick={downloadImages}
                    loading={downloadingImages}
                    appearance="primary"
                    color="cyan"
                  >
                    Download all Images
                  </Button>
                )}
              </>
            )} */}
              {(downloadAllImg && (user.PRDpicdwnld === true || user.Category === 'Admin')) && (
                <>
                  {alldata123.length > 0 && (
                    <Button
                      onClick={downloadImages}
                      loading={downloadingImages}
                      appearance="primary"
                      color="cyan"
                    >
                      Download all Images
                    </Button>
                  )}
                </>
              )}

              <Button onClick={updateCoverImages} appearance="primary" color="cyan">
                Update Images
              </Button>
            </ButtonToolbar>
          </div>
        </Stack>

        <Divider style={{ marginTop: '-7px', marginBottom: '5px' }} />
      </div>

      {changingImages && <Loader backdrop content="loading..." vertical />}

      <>
        <Panel
          style={{
            opacity: changingImages ? '0.5' : '1'
          }}
        >
          <FlexboxGrid justify="start" style={{ textAlign: 'center', marginTop: "160px" }} className="datatbl-img">
            {data123.map(item => (
              <>
                <ProductCard
                  {...{
                    item,
                    label,
                    selectallvar: () => { },
                    openVardata: () => { },
                    handleCheckboxChange,
                    selectedItems,
                    handleOpen: () => { },
                    // productUpdate,
                    pid: () => { },
                    showCheckbox: 1, // null means no preference
                    showEditIcon: 1, // null means no preference
                    showVariant: 0, // null means no preference
                    showQuickView: 0 // null means no preference
                  }}
                />
                {/* <ProductCard
                  {...{
                    
                    item,
                    label,
                    showQuickView: 0 // null means no preference, 0 = only product details ,1= quickview and product deatails
                  }}
                /> */}
              </>
            ))}
          </FlexboxGrid>
        </Panel>
        <Button ref={ref} style={{ visibility: 'hidden' }}></Button>
        <Stack justifyContent="flex-end">
          <IconButton
            size="sm"
            icon={<SortUpIcon />}
            active
            onClick={scrollToTop}
            style={{
              position: 'fixed',
              top: '90%',
              right: 10,
              transform: 'translateY(-50%)',
              zIndex: 9999
            }}
          />
        </Stack>
      </>

      <ImageEditModal
        {...{
          editOpen,
          setEditOpen,
          data123,
          setData123,
          selectedItems,
          setSelectedItems,
          deletePrevImg,
          fetchData,
          setCurrentPage,
          fileToBlob,
          resizeFile,
          base64ToBlob
        }}
      />
    </>
  );
};

export default ProductImage;
